import { Loader } from '@modules/common/components/Loader';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { captureException } from '@sentry/react';
import Analytics from 'common/Analytics.js';
import Locker from 'lockr';
import { useEffect } from 'react';
import AuthService from 'services/AuthService';
import { Userpilot } from 'userpilot';

interface LogoutProps {
  onLogoutCallback?: () => void;
}

export const Logout = ({ onLogoutCallback }: LogoutProps) => {
  const { showErrorNotification } = useNotificationContext();

  useEffect(() => {
    const logoutAction = () => {
      Analytics.track('User Signed Out');
      Userpilot?.clean();
      Locker.rm('token');
      Locker.rm('email');
      Locker.rm('preferredTaxonomyID');
      Locker.rm('adminTenant');
      Locker.rm('tenant');
      Locker.rm('isGoogleAuth');
      AuthService.removeTenantSlug();
      sessionStorage.removeItem('isDemoTenant');
      onLogoutCallback?.();
    };

    try {
      logoutAction();
    } catch (e) {
      captureException(e);
      showErrorNotification({
        contentComponent: 'Something went wrong',
        props: {},
      });
    }
  }, [onLogoutCallback, showErrorNotification]);

  return <Loader />;
};
